import {socketService} from "./game/socketService";
import {pixiComponents} from './game';
import {useEffect} from "react";
import "./App.css";
import {store} from "./game/store";
import {InfoSection} from "./game/infoSection";
import {isMobile} from "pixi.js";
import {HistorySection} from "./game/historySection";
import {ToastsContainer} from "./game/notifications/toastNotificatons/toastNotification";
import {ReconnectingModal} from "./game/notifications/reconnectingModal/reconnectingModal";
import {isHorizontalScreen} from "./game/utilites";
import {updateCanvasByMobileOrientation} from "./game/mobileRotation";
import {ConnectionLostModal} from "./game/notifications/connectionLostModal/connectionLostModal";
import {observer} from "mobx-react";


const App = observer(() => {
    useEffect(() => {
        window.addEventListener('resize', updateCanvasSize);
        document.getElementById("appBackground").style.backgroundImage = "url('./assets/bg.webp')";
        console.log("Demo Mode:" + store.isDemo());
        updateCanvasSize();

        return () => {
            pixiComponents.app?.destroy(true);
            socketService.stopConnection();
            window.removeEventListener('resize', updateCanvasSize);
        };
    }, []);


    return <div id={"appWrapper"}>
        <div id={"appBackground"}></div>
        <div id={"canvasContainer"}></div>
        <HistorySection/>
        {store.translations ? <InfoSection/> : null}
        <ReconnectingModal/>
        <ConnectionLostModal/>
        <ToastsContainer/>
    </div>;
});

export default App;

export const updateCanvasSize = () => {
    const canvasContainer = document.getElementById("canvasContainer");
    const canvas = canvasContainer.getElementsByTagName("canvas")[0];
    const {width, height} = canvasContainer.getBoundingClientRect();

    if (canvas) {
        if (canvas.width / canvas.height < width / height) {
            canvas.style.width = ""
            canvas.style.height = "100%"
        } else {
            canvas.style.width = "100%"
            canvas.style.height = ""
        }
    }

    if (!isMobile.phone) {
        const infoSection = document.getElementsByClassName("infoSection")[0];
        infoSection.style.scale = window.innerWidth / 1280;

        const historySection = document.getElementsByClassName("historySection")[0];
        historySection.style.scale = window.innerWidth / 1280;
    }

    if (isMobile.phone && pixiComponents.app) {
        store.setIsHorizontalScreen(isHorizontalScreen());
        updateCanvasByMobileOrientation();
        pixiComponents.cpItems.otherGamesSection.updateComponentsMetrics();
    }

    const otherGamesSectionContainer = document.getElementById("otherGamesSectionContainer");

    if (canvas && otherGamesSectionContainer) {
        const canvasProps = canvas.getBoundingClientRect();
        otherGamesSectionContainer.style.height = canvasProps.height + "px";
        otherGamesSectionContainer.style.width = canvasProps.width + "px";
        otherGamesSectionContainer.style.top = canvasProps.y + "px";
        otherGamesSectionContainer.style.left = canvasProps.x + "px";
    }
}
